/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Support_SuccessInputs */

const en_common_support_success = /** @type {(inputs: Common_Support_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticket submitted — we'll get back to you soon`)
};

const zh_common_support_success = /** @type {(inputs: Common_Support_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`工单已提交,我们会尽快回复`)
};

/**
* | output |
* | --- |
* | "Ticket submitted — we'll get back to you soon" |
*
* @param {Common_Support_SuccessInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_support_success = /** @type {((inputs?: Common_Support_SuccessInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Support_SuccessInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_support_success(inputs)
	return zh_common_support_success(inputs)
});
export { common_support_success as "common.support.success" }